import {store} from '../state/store'

let refreshTokenPromise;

const mountHttpError = (httpException) => {
    let error = {
        fromApi   : false,
        http_code : 500,
        http_body : {
            error : true,
            trace : 'GEN0001 - 00',
            message : 'Try again - 00',
            type :  'GENERIC - 00'
        }
    }
    if(httpException.response) {
        error = {
            fromApi  : true,
            http_code : httpException.response.status,
            http_body : {
                error : true,
                trace : ((httpException.response.data.trace ? httpException.response.data.trace : 'GEN0001')),
                message : ((httpException.response.data.message ? httpException.response.data.message : 'Try again.')),
                type :  ((httpException.response.data.type ? httpException.response.data.type : 'GENERIC')),
            }
        }
    }
    console.error(`Final Error: `, error);
    return error;
};

const setup = (http) => {
    http.interceptors.request.use (
      function (config) {
        if(store.state.session.logged){
            let jwt  = store.state.session.jwt;
            let idSessao = store.state.session.sessionId;
            config.headers["Authorization"] = "Bearer "+jwt;
            config.headers["sb-session"] = idSessao;
            config.headers["sb-version"] = process.env.VUE_APP_VERSION;
        }
        return config;
      },
      function (error) {
        console.dir('error', error);
        return Promise.reject(error);
      }
    );




    http.interceptors.response.use(r => r, error => {
        if (error.config && error.response && error.response.status === 401) {
            if (!refreshTokenPromise) {
                let actualRefresh = store.state.session.refreshToken;
                refreshTokenPromise = http.post(`/session/refresh/?refreshToken=${actualRefresh}`)
                    .then(({ data }) => {
                        let jwt = data.jwt;
                        let refreshToken = data.refreshToken;
                        let sessionId = store.state.session.sessionId
                        store.commit('setLogin', {jwt, refreshToken, sessionId});
                        refreshTokenPromise = null
                        return jwt;
                    }).catch(function(){
                        alert('Erro ao refresh token! logout imediato');
                        return null;
                    });
            }
            return refreshTokenPromise.then(token => {
                if (token == null) {
                    alert("erro depois 1");
                } else { 
                    error.config.headers['X-CSRF-TOKEN'] = token
                    return http.request(error.config)
                }
            })
        }
        return Promise.reject(mountHttpError(error))
    })

}


export default setup;